import React from 'react';
import { gbp } from '../utils/orderPricing';

const Row = ({ label, value, testId, className = '' }) => (
  <div className={`flex justify-between gap-4 ${className}`}>
    <span>{label}</span>
    <span className="whitespace-nowrap" data-testid={testId}>{value}</span>
  </div>
);

export const OrderSummary = ({ packageName, summary }) => (
  <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-6 space-y-3" data-testid="order-summary">
    <h3 className="font-bold text-lg mb-3">Order Summary</h3>
    <Row label={`${packageName} - full package price`} value={gbp(summary.packagePrice)} testId="summary-package-price" className="text-sm" />
    <div className="pt-1">
      <p className="text-xs uppercase tracking-wider text-gray-400 mb-2">Selected add-ons</p>
      {summary.addons.length === 0 ? (
        <p className="text-sm text-gray-500" data-testid="summary-no-addons">No add-ons selected</p>
      ) : (
        <div className="space-y-2">
          {summary.addons.map((a) => (
            <Row key={a.id} label={a.label} value={`+${gbp(a.amount)}`} testId={`summary-addon-${a.id}`} className="text-sm text-gray-200" />
          ))}
        </div>
      )}
    </div>
    <div className="border-t border-amber-500/30 pt-3 mt-3 space-y-2">
      <Row label="Total order price" value={gbp(summary.total)} testId="summary-total" className="font-bold text-lg" />
      <Row label="Booking deposit payable today" value={gbp(summary.deposit)} testId="summary-deposit" className="text-sm font-semibold text-amber-400" />
      <Row label="Remaining balance payable later" value={gbp(summary.remaining)} testId="summary-remaining" className="text-sm text-gray-200" />
    </div>
    <p className="text-xs text-gray-400 leading-relaxed pt-1" data-testid="summary-deposit-terms">
      Deposits are fixed per package and don't change with add-ons, so add-ons are added to your remaining balance.
    </p>
  </div>
);

export default OrderSummary;
